import { useEffect } from 'react';

/**
 * Injects page-specific JSON-LD <script> tags on mount/route change and
 * removes them on cleanup, so each route gets its own schema instead of
 * the one identical block previously shared site-wide. Site-wide entities
 * (Person, Organization, WebSite, Book) stay static in public/index.html.
 */
export default function usePageSchema(schemas) {
  useEffect(() => {
    if (!schemas || !schemas.length) return undefined;

    const nodes = schemas.map((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-page-schema', 'true');
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      nodes.forEach((node) => node.remove());
    };
  }, [JSON.stringify(schemas)]); // eslint-disable-line
}
